// src/pages/Home.js
import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import VisionMission from '../components/VisionMission';
import LogisticsGallery from '../components/LogisticsGallery';
import OurServices from '../components/OurServices';
import LogisticsTabs from '../components/LogisticsTabs';
import SmartDelivery from '../components/SmartDelivery';
import Footer from '../components/Footer';

function Home() {
    return (
        <>
            {/* <Header /> */}
            {/* <HeroSection />
            <AboutSection />
            <VisionMission />
            <LogisticsGallery />
            <OurServices />
            <LogisticsTabs />
            <SmartDelivery />
            <Footer /> */}
        </>
    );
}

export default Home;
